import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { formatValue } from '@/shared/lib/format';
import type { DocumentForecast } from '../api/schemas';
import { PageCite } from './PageCite';

type Props = { forecasts: DocumentForecast[]; onOpenPage: (page: number) => void };

const FALLBACK_ROWS = 12;

/** The report's forecasts, led by the instruments it is about (the server sorts them so); the rest on request. */
export function ReportForecasts({ forecasts, onOpenPage }: Props) {
  const [showAll, setShowAll] = useState(false);
  if (forecasts.length === 0) return null;
  const featured = forecasts.filter((f) => f.featured);
  const lead = featured.length > 0 ? featured : forecasts.slice(0, FALLBACK_ROWS);
  const rows = showAll ? forecasts : lead;

  return (
    <section aria-labelledby="forecasts-in-report">
      <Typography id="forecasts-in-report" variant="h4" component="h2" sx={{ mb: 1.5 }}>Forecasts in this report</Typography>
      <TableContainer>
        <Table size="small" aria-labelledby="forecasts-in-report">
          <TableHead>
            <TableRow>
              <TableCell>Instrument</TableCell>
              <TableCell>Period</TableCell>
              <TableCell align="right">Forecast</TableCell>
              <TableCell align="right">Source</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((f) => (
              <TableRow key={`${f.instrument}-${f.periodLabel}`}>
                <TableCell>{f.instrument}</TableCell>
                <TableCell>{f.periodLabel}</TableCell>
                <TableCell align="right">{formatValue(f.value)}</TableCell>
                <TableCell align="right"><PageCite page={f.page} onOpen={onOpenPage} /></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {forecasts.length > lead.length ? (
        <Button size="small" onClick={() => { setShowAll((v) => !v); }} sx={{ mt: 1 }}>
          {showAll ? 'Show the main pairs only' : `Show all ${forecasts.length} forecasts`}
        </Button>
      ) : null}
    </section>
  );
}
